import { FC, Fragment } from "react";

import { Box } from "@mui/material";

interface FuzzyHighlightProps {
  text: string;
  search: string;
}

const FuzzyHighlight: FC<FuzzyHighlightProps> = ({ text, search }) => {
  if (!search) return <>{text}</>;

  const cleanSearch = search.toLowerCase();
  let searchIdx = 0;

  return (
    <Box component="span">
      {text.split("").map((char, index) => {
        const isMatch = searchIdx < cleanSearch.length && char.toLowerCase() === cleanSearch[searchIdx];

        if (isMatch) {
          searchIdx++;
        }

        const uniqueKey = `char-${index}-${char}`;

        return isMatch ? (
          <Box
            key={uniqueKey}
            component="mark"
            sx={{
              backgroundColor: "yellow",
              color: "black",
              borderRadius: "2px",
              padding: "0 1px",
            }}
          >
            {char}
          </Box>
        ) : (
          <Fragment key={uniqueKey}>{char}</Fragment>
        );
      })}
    </Box>
  );
};

export default FuzzyHighlight;
